import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getAllCommercial_Api,
  getAllUserCommercial_Api,
  getNearYouCommercial_Api,
  getPopularCommercial_Api
} from "../apis/CommercialApis";
import { PlacesStatsApis, StatusTabPressPlaceDetailsApis } from "../apis/PlacesApis";
import {
  setAllCommercialData,
  setAllNearCommercialData,
  setAllPlacesData,
  setAllPopularCommercialData,
  setAllUserCommercialData,
  setStatsOfPlaces,
  setUser
} from "../redux/action";
export const useGetPlacesHooks = (setisOpen) => {
  //all redux
  const user_redux = useSelector((s) => s?.user ?? {});
  const place_stats_redux = useSelector((s) => s?.placeStats ?? {});
  const [placesData, setPlacesData] = useState([]);
  const dispatch = useDispatch();
  const [placeId, setPlaceId] = useState(null)
  const [userLocation, setUserLocation] = useState(null);
  const [error, setError] = useState(null);
  const [time, setTime] = useState('today');
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setUserLocation({
            latitude: position?.coords?.latitude,
            longitude: position?.coords?.longitude,
          });
          dispatch(setUser({
            ...user_redux,
            location: {
              ...user_redux.location,
              coordinates: [position?.coords?.latitude, position?.coords?.longitude]
            }
          }))
        },
        (err) => {
          setError(err.message);
        }
      );
    } else {
      setError('Geolocation is not supported by this browser.');
    }
  }, []);
  useEffect(() => {
    if (user_redux && Object.keys(user_redux).length > 0) {
      fetchStatusItems();
    }
  }, [user_redux]);
  useEffect(() => {
    getAllCommercialApiFunc();
    getPopluarCommercialApiFunc();
    getNearCommercialsApiFunc();
    getNearCommercialsApiFunc();
    getAllUserCommercialApiFunc()
  }, []);
  useEffect(() => {
    if (placeId, time) {
      getAllStatsOfPlace()
    }
  }, [placeId, time])
  const fetchStatusItems = async () => {
    const result = await StatusTabPressPlaceDetailsApis("");
    if (result.success) {
      setPlacesData(result?.data?.places || []);
      dispatch(setAllPlacesData(result?.data?.commercials));
      console.log("data is set", result?.data?.commercials);
    } else {
      setPlacesData([]);
    }
  };
  const getAllCommercialApiFunc = async () => {
    const result = await getAllCommercial_Api();
    if (result.success) {
      dispatch(setAllCommercialData(result?.data?.commercials));
    }
  };
  const getAllStatsOfPlace = async () => {
    try {
      const result = await PlacesStatsApis(placeId, time);
      if (result.success) {
        dispatch(setStatsOfPlaces(result.data?.data?.stats));
      } else {
        console.error("Failed to fetch stats:", result.error);
      }
    } catch (err) {
      console.error("Unexpected error while fetching stats:", err);
    }
  };
  const getAllUserCommercialApiFunc = async () => {
    const result = await getAllUserCommercial_Api();
    if (result.success) {
      dispatch(setAllUserCommercialData(result?.data?.commercials));
    }
  };
  const getPopluarCommercialApiFunc = async () => {
    const result = await getPopularCommercial_Api();
    if (result.success) {
      dispatch(setAllPopularCommercialData(result?.data?.commercials));
    }
  };
  const getNearCommercialsApiFunc = async () => {
    const result = await getNearYouCommercial_Api({
      lat: user_redux?.location?.coordinates[0],
      lng: user_redux?.location?.coordinates[1],
      radius: 100
    });
    if (result.success) {
      dispatch(setAllNearCommercialData(result?.data?.commercials));
    }
  };
  return {
    //local states
    placesData,
    placeId, setPlaceId, place_stats_redux, time, setTime
  };
};
